import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { FacebookShareButton, TumblrShareButton, TwitterShareButton } from 'react-share';
export const ShareButton = (_param)=>{
    var { type , url , title , via , hashtags =[] , media =url , children  } = _param, props = _object_without_properties(_param, [
        "type",
        "url",
        "title",
        "via",
        "hashtags",
        "media",
        "children"
    ]);
    switch(type){
        case 'facebook':
            return /*#__PURE__*/ React.createElement(FacebookShareButton, _extends({
                quote: title,
                hashtag: hashtags.length ? `#${hashtags[0]}` : '',
                url: url
            }, props), children);
        case 'twitter':
            return /*#__PURE__*/ React.createElement(TwitterShareButton, _extends({
                url: url,
                title: title,
                via: via,
                hashtags: hashtags
            }, props), children);
        case 'tumblr':
            return /*#__PURE__*/ React.createElement(TumblrShareButton, _extends({
                url: url,
                title: title,
                tags: hashtags,
                caption: title
            }, props), children);
        default:
            return null;
    }
};
ShareButton.displayName = 'ShareButton';
export default ShareButton;
